const env = process.env.REACT_APP_ENV;
const LOCAL_KEY = '65e28bfacf5259a5bc3d4c4281fd5d36367507d6bab44fed5abedf6e1933cfb6';
const UAT_KEY = '8a5f92914ba346dab85a84185ee70248c943c631257a446b01c4700ecb02c229';
const PROD_KEY = '00b1ebba41dfe403fb5f58ee2f8e14b84f69676e82708f1a52cf8c18303f2ec1';
const CONFIG_KEY = env == 'UAT' ? UAT_KEY : env == 'PROD' ? PROD_KEY : LOCAL_KEY;
export default CONFIG_KEY;